import MeetingTransparencyMixin from '@/core/mixins/meeting-transparency.mixin';
import Component from 'vue-class-component';
import { Mixins, Watch, Prop } from 'vue-property-decorator';
import { COURSE_EVENTS } from '@/content/values/events';
import { CLASS_BY_OBJECT_TYPE, RESIZE_TYPES, IFRAME_EVENT_TYPES, TRANSPARENCY_EVENTS, SPLIT_TYPES, CLASS_ELEMENTS, SECTION_TYPE_CODES, INTERNAL_ELEMENT_CLASSES, KEYBOARD_ARROWS_TYPES } from '@/core/values/ed-transparency-meeting.values';
import { SEND_CURRENT_SHARED_TASK_EVENT } from '@/content/values/ed-presentation-mode.values';
import EdWhiteboardMenu from '@/core/components/ed-meeting-transparency/ed-whiteboard-menu/ed-whiteboard-menu.component.vue';
import { BOARD_EVENTS } from '@/values/ed-whiteboard.values';
import { LOADING_EVENTS } from '@/core/values/core.values';
import { EdBoardV2 } from '@/components/common/ed-board/ed-board-v2.component.vue';

@Component({
    components: {
        EdWhiteboardMenu,
        EdBoardV2
    }
})
export default class EdTeacherMeetingTransparency extends Mixins(MeetingTransparencyMixin) {

    @Prop({default: true}) public scrollable : boolean;
    @Prop({default: false}) public sendBehind : boolean;

    public isLoading : boolean = true;
    public styles : any = {};
    private minimizedHomeworksSideBarId : string ='minimizedHomeworksSideBar'
    private leftPadding : number = 14;
    private documentContainer : any = null;
    private isWhiteboardLoading : boolean = true;
    private isMinimizedHomeworksSideBar : boolean = false;

    get isTransparencyBoardBehind () {
        return !this.isWhiteboardTransparency && this.sendBehind;
    }

    public async loadMessages() : Promise<void> {
        this.isWhiteboardLoading = false;

        this.obtainContainer();
        await this.obtainScreenInfo();
        this.scrollWhiteboard();

        this.$edEventBus.$emit(COURSE_EVENTS.SEND_TRANSPARENT_WHITEBOARD);
        this.$edEventBus.$emit(SEND_CURRENT_SHARED_TASK_EVENT);
        this.showMenu = true;
    }

    public onScroll(event : any) : void {
        let scrollTop : number = event.target.scrollTop;
        let sectionContainer = document.querySelector(`#${this.preDocumentId}${this.documentHash} > .ed-file-presentation`) ||
                                    document.querySelector('.ed-images-viewer') || document.querySelector('.ed-video-viewer');
        sectionContainer?.scrollTo(0, scrollTop);
    }

    private changeDocumentResize({width, height, homeworksSideBar}: {width: number, height: number, homeworksSideBar: boolean}) : void {
        this.$edEventBus.$emit(BOARD_EVENTS.RESIZE_BOARD);
        if(this.isWhiteboardLoading || !this.documentContainer){
            return;
        }

        this.isMinimizedHomeworksSideBar = !homeworksSideBar;
    }


    private obtainScreenInfo() : Promise<void> {
        return new Promise((resolve, reject) => {
            if(!this.documentContainer){
                resolve();
                return;
            }

            this.obtainElementContainer();
            this.addMarginTopToDocument();
            let containerWidth  : number = this.documentContainer.offsetWidth;
            let documentHeight  : number = this.documentContainer.scrollHeight - this.translateTopDefault;
            let widthElement    : number = containerWidth;

            if(!RESIZE_TYPES.includes(this.presentationModeViewerType)){
                widthElement = this.elementContainer.offsetWidth;
            }

            this.setDocumentContainerHeight();

            if((!RESIZE_TYPES.includes(this.presentationModeViewerType) || SECTION_TYPE_CODES.LESSON_PDF == this.presentationModeViewerType) && (this.isMinimizedHomeworksSideBar || !this.zoomObject)){
                containerWidth = this.changePDFStyles();
            }

            if(RESIZE_TYPES.includes(this.presentationModeViewerType)){
                documentHeight = this.elementContainer.scrollHeight;
            }

            this.documentContainer.style.overflow = 'hidden';
            this.whiteboardInfo = {width: widthElement, height: documentHeight};
            resolve();
        })
    }

    public setDocumentContainerHeight() {
        if (this.presentationModeViewerType !== SECTION_TYPE_CODES.LESSON_IMAGES) {
            const container = this.documentContainer ?? document.getElementsByClassName(CLASS_BY_OBJECT_TYPE[this.presentationModeViewerType])[this.documentIndex];
            this.styles = {height: `${container.offsetHeight}px`};
        }
    }

    private addMarginTopToDocument(){
        this.elementContainer.style.setProperty('transform', `translateY(${this.translateTopDefault}px)`);
    }

    private changePDFStyles() : number {
        if(!(SPLIT_TYPES.includes(this.presentationModeViewerType) && this.isSplitVertical) && this.zoomObject){
            let elementTest : any = this.elementContainer.getElementsByClassName(INTERNAL_ELEMENT_CLASSES[this.presentationModeViewerType])[0];
            let pdfBoundingClientRect = elementTest.getBoundingClientRect();
            this.styles = { left: `${pdfBoundingClientRect.left - this.leftPadding}px`, width: '75.5%' };
        }

        if(!this.zoomObject){
            this.styles = { left: `${this.elementContainer.offsetLeft}px`, width: `${this.elementContainer.offsetWidth}px` };
        }
        return this.elementContainer.offsetWidth;
    }

    private transparencyScroll(data : any) : void {
        if(data.scrollTop === null || !CLASS_BY_OBJECT_TYPE[this.presentationModeViewerType] || !this.documentContainer){
            return;
        }
        this.documentContainer.scrollTo(0, data.scrollTop);
    }

    private obtainContainer() : void {
        const className: string = CLASS_BY_OBJECT_TYPE[this.presentationModeViewerType];
        const index: number = SPLIT_TYPES.includes(this.presentationModeViewerType) && this.areMultiplePresentationModeViewerTypes ?
            0 : this.documentIndex;
        this.documentContainer = document.getElementsByClassName(className)[index];
    }

    private async changeDocumentZoom(page?) {
        await this.obtainScreenInfo();
        this.$edEventBus.$emit(`${BOARD_EVENTS.RESIZE_BOARD}-${page}`, true);
    }

    private scrollWhiteboard() {
        let elementScrollTop = this.documentContainer?.scrollTop || 0;
        const pageImageContainer = document.getElementById(`page-container-${this.whiteboardPath}`);
        if(pageImageContainer && pageImageContainer.scrollHeight >= elementScrollTop) {
            pageImageContainer.scrollTo(0, elementScrollTop);
        } else {
            setTimeout(() => {
                this.scrollWhiteboard();
            }, 500);
        }
    }

    keyboardArrows() {
        if(KEYBOARD_ARROWS_TYPES.includes(this.presentationModeViewerType)){
            const pageImageContainer = document.getElementById(`page-container-${this.whiteboardPath}`);
            if(pageImageContainer) {
                document.addEventListener('keydown', this.moveArrow, false);
            } else {
                setTimeout(() => {
                    this.keyboardArrows();
                }, 500);
            }
        }
    }

    removeKeyboardArrows() {
        if(KEYBOARD_ARROWS_TYPES.includes(this.presentationModeViewerType)) {
            const pageImageContainer = document.getElementById(`page-container-${this.whiteboardPath}`);
            if(pageImageContainer)
                document.removeEventListener('keydown', this.moveArrow, false);
        }
    }

    moveArrow(event) {
        if(event.keyCode === 37 || event.keyCode === 39) {
            if(this.presentationModeViewerType === SECTION_TYPE_CODES.LESSON_PPT_HTML) {
                this.changeSlide(event.keyCode);
            }
        }
    }

    changeSlide(data: any) {
        let message = {
            data: data,
            type: 'moveSlide'
        }
        this.$edEventBus.$emit(COURSE_EVENTS.MOVE_SLIDE, message);
    }

    @Watch('showBoard')
    private showBoardChanged() {
        if(this.showBoard) {
            this.scrollWhiteboard();
        }
    }

    async mounted() {
        this.$edEventBus.$emit(COURSE_EVENTS.FORCE_SEND_SCROLL);
        this.$edEventBus.$on(BOARD_EVENTS.CLOSE_LOADING_BOARD_TASK, this.closeLoading);
        this.$edEventBus.$on(BOARD_EVENTS.BOARD_READY, this.closeLoading);
        this.$edEventBus.$on(BOARD_EVENTS.INIT_BOARD_TASK, this.initBoard)
        this.connect();
        this.loadMessages();
        this.$edEventBus.$emit(LOADING_EVENTS.SHOW, this.$i18n.t('common.loadingPresentationMode'));
        this.isMinimizedHomeworksSideBar = document.getElementById(this.minimizedHomeworksSideBarId) ? true : false;
        await this.loadWhiteboardPath();
        setTimeout(() => {
            this.isLoading = false;
            this.scrollWhiteboard();
            this.keyboardArrows();
        });
        this.$edEventBus.$on(COURSE_EVENTS.CHANGE_RESIZE, this.changeDocumentResize);
        this.$edEventBus.$on(`${TRANSPARENCY_EVENTS.SCROLL_EVENT}${this.documentIndex}`, this.transparencyScroll);
        this.$edEventBus.$on(TRANSPARENCY_EVENTS.CHANGE_DOCUMENT_ZOOM, this.changeDocumentZoom);
        this.$edEventBus.$on(`${TRANSPARENCY_EVENTS.SCROLL_EVENT}`, this.scrollWhiteboard);
    }

    beforeDestroy() {
        this.disconnectSocket();
        if(this.documentContainer){
            this.documentContainer.style.overflow = 'auto';
        }
        this.$edEventBus.$off(COURSE_EVENTS.CHANGE_RESIZE, this.changeDocumentResize);
        this.$edEventBus.$off(`${TRANSPARENCY_EVENTS.SCROLL_EVENT}${this.documentIndex}`, this.transparencyScroll);
        this.$edEventBus.$off(TRANSPARENCY_EVENTS.CHANGE_DOCUMENT_ZOOM, this.changeDocumentZoom);
        if(this.elementContainer){
            this.elementContainer.style.removeProperty('transform');
        }
        this.$edEventBus.$off(`${TRANSPARENCY_EVENTS.SCROLL_EVENT}`, this.scrollWhiteboard);
        this.$edEventBus.$off(BOARD_EVENTS.CLOSE_LOADING_BOARD_TASK, this.closeLoading);
        this.$edEventBus.$off(BOARD_EVENTS.BOARD_READY, this.closeLoading);
        this.$edEventBus.$off(BOARD_EVENTS.INIT_BOARD_TASK, this.initBoard);
        this.removeKeyboardArrows();
    }

}
